import React, {Component} from "react";
import {Nav, Table} from "react-bootstrap";
import axios from "axios";
import {ClockLoader} from "react-spinners";
import Moment from "moment";

//TODO: the refresh needs a timer on it. Otherwise it just runs all the time

export class FinanceAllHours extends Component{

    constructor() {
        super();
        this.state = {
            filterOption: '',
            filteredData: [],
            newData: [],
            invoiceIsLoading: true,
            sum: [],
            userInfo: [],
        };
    }

    componentDidMount() {
        const userInfo =  JSON.parse(localStorage.getItem('userInfo')) ?? {};
        axios.get('https://homesafetysolutions.pythonanywhere.com/api/all_worked_hours/',{
            headers:{
                "Accept":'application/json',
                "Content-Type":'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        })
            .then(response=>{
                this.setState({newData: response.data});
                this.setState({invoiceIsLoading: false});
            })
    }

    optionSelected(e) {
        this.setState({
            filterOption: e.target.value,
        });
    }

    renderTableData(newData) {
        // console.log(newData)
        return newData.map((element, i) => (
            <tr key={i}>
                <td>{Moment(element.created).format("MM/DD/YYYY  hh:mm:ss a")}</td>
                <td>{element.client_name}</td>
                <td>{element.employees_onsite}</td>
                <td>{element.hours}</td>
                <td>{element.minutes}</td>
                <td>{element.finished}</td>
                <td>{element.rework}</td>
                <td>{element.work_description}</td>
            </tr>
        ));
    };

    renderFilterOptions(filterOption) {
        if(filterOption) {
            let { newData } = this.state;
            let options = Array.from(new Set(newData.map(element => element[filterOption])));
            return options.map((option,i) => <option key={i} value={option}> {option} </option>)
        }
        return []
    };

    filterOptionSelected(e) {
        let {value} = e.target;
        if(value) {
            let { filterOption, newData } = this.state
            let filteredData = newData.filter(element => element[filterOption] === value);

            const getSum = filteredData.reduce((obj, {minutes}) => {
                obj[minutes] = minutes;

                return obj;
            }, {});

            let sum = 0;
            for (const value of Object.values(getSum)) {
                // console.log(value)
                sum += parseInt(value);
            }


            this.setState({
                filteredData: filteredData,
                getSum: getSum,
                // sum: sum.toFixed(2),
                sum: `Hr:${sum.toFixed(0)}`
            });
        }
    };


    render() {
        let { filterOption, filteredData, newData, invoiceIsLoading, sum} = this.state

        if (invoiceIsLoading){
            return <div className={'loadingSpinner'} >Loading...<br/> <ClockLoader color="#0d00ff" /></div>
        }

        return (
            <div>

                <h1 className={'perposalInvoiceHeaders'}>All Hours Worked</h1>
                <div>
                    <label>Filter By:</label>
                    <br/>
                    <select onChange={this.optionSelected.bind(this)}>
                        <option value="">  </option>
                        <option value="client_name">Client</option>
                        <option value="employees_onsite">Employees On Site</option>
                        <option value="finished">Finished</option>
                        <option value="rework">Rework</option>
                        <option value="year">Year</option>
                        <option value="year_and_month">Month & Year</option>
                    </select>

                    <select onChange={this.filterOptionSelected.bind(this)}>
                        <option value="">  </option>
                        {this.renderFilterOptions(filterOption)}
                    </select>
                </div>
                <Table responsive="lg" className={'mt-4'} striped bordered hover size={'lg'}>
                    <thead>
                    <th>S.O. Created On:</th>
                    <th>Client Address:</th>
                    <th>Employees On Site:</th>
                    <th>Hours:</th>
                    <th>Minutes:</th>
                    <th>Finished:</th>
                    <th>Rework:</th>
                    <th>Work Description:</th>
                    </thead>
                    <tbody>
                    {
                        filteredData.length ? this.renderTableData(filteredData) : this.renderTableData(newData)
                    }
                    {/*<div className={'reportsSum'}>*/}
                    {/*    TOTAL: {sum}*/}
                    {/*</div>*/}

                    </tbody>
                </Table>
            </div>
        );
    }
}

export default FinanceAllHours;
